import(/* webpackMode: "eager" */ "/codebuild/output/src2996342916/src/website/src/app/portfolio/page.jsx")